/** Day and month only, German, no year — e.g. „12. März“. */
export function formatColleagueBirthday(month: number, day: number): string {
  return new Date(Date.UTC(2000, month - 1, day)).toLocaleDateString('de-DE', {
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  });
}

export function colleagueInitials(displayName: string): string {
  return displayName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0] ?? '')
    .join('')
    .toLocaleUpperCase('de-DE');
}
